export default __webpack_public_path__ + "media/Number15.ebd412e52c08e060f36d30a84441ca25.mp4";